import ServerApi from "./../../../libs/api-services/server-api"

class CantonService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/cantons/"
}

export const cantonService = new CantonService()
